import { UUID21wrnrlmk5y1y as UUID } from './UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { UUIDSerializer_getInstance2ms0oa88en0c as UUIDSerializer_getInstance } from './serialization/Serializers.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeferToContextualUuidSerializerClass;
function DeferToContextualUuidSerializer() {
  if (DeferToContextualUuidSerializerClass === VOID) {
    class $ {
      constructor() {
        DeferToContextualUuidSerializer_instance = this;
        var tmp = this;
        var tmp_0 = getKClass(UUID());
        var tmp_1 = UUIDSerializer_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.p3n_1 = ContextualSerializer().zy(tmp_0, tmp_1, tmp$ret$2);
      }
      az() {
        return this.p3n_1.xy_1;
      }
      q3n(encoder, value) {
        this.p3n_1.lz(encoder, value);
      }
      oz(encoder, value) {
        return this.q3n(encoder, value instanceof UUID() ? value : THROW_CCE());
      }
      pz(decoder) {
        return this.p3n_1.pz(decoder);
      }
    }
    initMetadataForObject($, 'DeferToContextualUuidSerializer', VOID, VOID, [KSerializer()]);
    DeferToContextualUuidSerializerClass = $;
  }
  return DeferToContextualUuidSerializerClass;
}
var DeferToContextualUuidSerializer_instance;
function DeferToContextualUuidSerializer_getInstance() {
  if (DeferToContextualUuidSerializer_instance === VOID)
    new (DeferToContextualUuidSerializer())();
  return DeferToContextualUuidSerializer_instance;
}
//region block: exports
export {
  DeferToContextualUuidSerializer_getInstance as DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4,
};
//endregion

//# sourceMappingURL=UUID.mjs.map
